export default function UpgradeModal({ open, onClose }) {
  if (!open) return null;

  return (
    <>
      <style>{`
        @keyframes um-card-in {
          from { opacity: 0; transform: translateY(16px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes um-row-in {
          from { opacity: 0; transform: translateY(8px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .um-card {
          animation: um-card-in .45s ease-out both;
        }
        .um-benefit-row {
          opacity: 0;
          animation: um-row-in .35s ease-out both;
        }
        .um-benefit-row:nth-child(1) { animation-delay: .28s; }
        .um-benefit-row:nth-child(2) { animation-delay: .38s; }
        .um-benefit-row:nth-child(3) { animation-delay: .48s; }
      `}</style>

      {/* Backdrop */}
      <div
        onClick={e => { if (e.target === e.currentTarget) onClose(); }}
        style={{
          position: 'fixed', inset: 0,
          background: 'rgba(30,45,74,.45)',
          zIndex: 500,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          padding: '0 20px',
        }}
      >
        {/* Card */}
        <div
          className="um-card"
          style={{
            width: '100%', maxWidth: 400,
            background: '#FAF6F0',
            borderRadius: 20,
            overflow: 'hidden',
            boxShadow: '0 24px 64px rgba(30,45,74,.18)',
          }}
        >
          {/* Header band */}
          <div style={{
            background: '#FBF0DB',
            padding: '30px 24px 22px',
            display: 'flex', flexDirection: 'column', alignItems: 'center',
            borderBottom: '1px solid rgba(30,45,74,.08)',
          }}>
            {/* Sun mark logo */}
            <svg width="80" height="80" viewBox="0 0 32 32" fill="none" style={{ marginBottom: 12 }}>
              <circle cx="16" cy="16" r="8" fill="#F5A623"/>
              {[0,45,90,135,180,225,270,315].map((deg, i) => (
                <line key={i} x1="16" y1="4" x2="16" y2="1.5"
                  stroke="#F5A623" strokeWidth="2" strokeLinecap="round"
                  transform={`rotate(${deg} 16 16)`}/>
              ))}
            </svg>
            <span style={{
              fontFamily: "'DM Sans', sans-serif",
              fontSize: 11, fontWeight: 500,
              letterSpacing: '.2em',
              textTransform: 'uppercase',
              color: '#9a8a6e',
            }}>
              Solis Premium
            </span>
          </div>

          {/* Body */}
          <div style={{ padding: 24 }}>
            {/* Headline */}
            <div style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: 25, fontWeight: 600,
              color: '#1E2D4A', lineHeight: 1.2,
              marginBottom: 10,
            }}>
              Looks like you've caught the travel bug.
            </div>

            {/* Subhead */}
            <div style={{
              fontFamily: "'DM Sans', sans-serif",
              fontSize: 15, color: '#5b6580',
              lineHeight: 1.55, marginBottom: 22,
            }}>
              You've used all three of your free trips — not bad for this much wanderlust. Go unlimited and keep the adventures coming.
            </div>

            {/* Benefit rows */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: 15, marginBottom: 22 }}>
              {/* Row 1 — Unlimited trips */}
              <div className="um-benefit-row" style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                <div style={{
                  width: 32, height: 32, borderRadius: '50%',
                  background: '#FAEEDA',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  flexShrink: 0,
                }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M12 12c-2.5-3-6.5-3-6.5 0s4 3 6.5 0 6.5 3 6.5 0-4-3-6.5 0z"
                      stroke="#854F0B" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                </div>
                <div>
                  <div style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 15, fontWeight: 500, color: '#1E2D4A' }}>
                    Unlimited trips
                  </div>
                  <div style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13, color: '#66708a' }}>
                    Plan as many as you dream up
                  </div>
                </div>
              </div>

              {/* Row 2 — Multi-city */}
              <div className="um-benefit-row" style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                <div style={{
                  width: 32, height: 32, borderRadius: '50%',
                  background: '#FAEEDA',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  flexShrink: 0,
                }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <circle cx="5"  cy="18" r="2" stroke="#854F0B" strokeWidth="2"/>
                    <circle cx="12" cy="6"  r="2" stroke="#854F0B" strokeWidth="2"/>
                    <circle cx="19" cy="18" r="2" stroke="#854F0B" strokeWidth="2"/>
                    <path d="M5 16 L12 8 L19 16" stroke="#854F0B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div>
                  <div style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 15, fontWeight: 500, color: '#1E2D4A' }}>
                    Multi-city journeys
                  </div>
                  <div style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13, color: '#66708a' }}>
                    String 2–6 destinations into one trip
                  </div>
                </div>
              </div>

              {/* Row 3 — Everything you love */}
              <div className="um-benefit-row" style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                <div style={{
                  width: 32, height: 32, borderRadius: '50%',
                  background: '#FAEEDA',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  flexShrink: 0,
                }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M12 21C12 21 3 14 3 8.5a4.5 4.5 0 0 1 9-0.5 4.5 4.5 0 0 1 9 .5C21 14 12 21 12 21z"
                      stroke="#854F0B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div>
                  <div style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 15, fontWeight: 500, color: '#1E2D4A' }}>
                    Everything you already love
                  </div>
                  <div style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13, color: '#66708a' }}>
                    Itineraries, voting, expenses, journal & map
                  </div>
                </div>
              </div>
            </div>

            {/* Pricing cards */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 18 }}>
              {/* Yearly */}
              <div style={{
                border: '2px solid #F5A623',
                borderRadius: 14,
                background: '#FFFDF8',
                padding: '14px 10px',
                display: 'flex', flexDirection: 'column', alignItems: 'center',
                gap: 2,
              }}>
                <span style={{
                  fontSize: 11, fontWeight: 500,
                  color: '#B5780F',
                  background: '#FEF0DC',
                  borderRadius: 100,
                  padding: '2px 8px',
                  marginBottom: 4,
                  fontFamily: "'DM Sans', sans-serif",
                }}>Best value · save 35%</span>
                <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13, color: '#66708a' }}>Yearly</span>
                <span style={{ fontFamily: "'Playfair Display', serif", fontSize: 22, fontWeight: 600, color: '#1E2D4A' }}>$69.99</span>
                <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 12, color: '#66708a' }}>per year</span>
              </div>

              {/* Monthly */}
              <div style={{
                border: '1.5px solid #e6dfd0',
                borderRadius: 14,
                background: '#fff',
                padding: '14px 10px',
                display: 'flex', flexDirection: 'column', alignItems: 'center',
                gap: 2,
                justifyContent: 'center',
              }}>
                <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13, color: '#66708a' }}>Monthly</span>
                <span style={{ fontFamily: "'Playfair Display', serif", fontSize: 22, fontWeight: 600, color: '#1E2D4A' }}>$8.99</span>
                <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 12, color: '#66708a' }}>per month</span>
              </div>
            </div>

            {/* Trial reassurance */}
            <div style={{
              fontFamily: "'DM Sans', sans-serif",
              fontSize: 13, color: '#66708a',
              textAlign: 'center',
              marginBottom: 12,
            }}>
              3-day free trial included! Cancel anytime.
            </div>

            {/* CTA */}
            <button
              onClick={() => {
                // TODO: wire payment (step 6)
              }}
              style={{
                width: '100%',
                padding: 15,
                background: '#F5A623',
                color: '#1E2D4A',
                border: 'none',
                borderRadius: 14,
                fontFamily: "'DM Sans', sans-serif",
                fontSize: 16, fontWeight: 500,
                cursor: 'pointer',
                marginBottom: 14,
              }}
            >
              Go premium
            </button>

            {/* Maybe later */}
            <div style={{ textAlign: 'center' }}>
              <span
                onClick={onClose}
                style={{
                  fontFamily: "'DM Sans', sans-serif",
                  fontSize: 14, color: '#66708a',
                  cursor: 'pointer',
                }}
              >
                Maybe later
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
